const landing = document.querySelector("#landing");
const wizard = document.querySelector("#wizard");
const studio = document.querySelector("#studio");
const landingHeader = document.querySelector("#landingHeader");
const landingName = document.querySelector("#landingName");
const landingStartBtn = document.querySelector("#landingStartBtn");
const startWizardButtons = [...document.querySelectorAll("[data-start-wizard]")];
const templateButtons = [...document.querySelectorAll("[data-template-occasion]")];

const form = document.querySelector("#briefForm");
const pages = [...document.querySelectorAll(".step-page")];
const wizardStepLabel = document.querySelector("#wizardStepLabel");
const wizardProgress = document.querySelector("#wizardProgress");
const wizardPercent = document.querySelector("#wizardPercent");
const backBtn = document.querySelector("#backBtn");
const nextBtn = document.querySelector("#nextBtn");
const submitBtn = document.querySelector("#submitBtn");
const startOverBtn = document.querySelector("#startOverBtn");
const saveCloseBtn = document.querySelector("#saveCloseBtn");
const studioRestartBtn = document.querySelector("#studioRestartBtn");
const relationshipHeading = document.querySelector("#relationshipHeading");
const referenceInput = document.querySelector("#referenceInput");
const referenceStrip = document.querySelector("#referenceStrip");
const storySeedInput = document.querySelector("#storySeedInput");
const storyCounter = document.querySelector("#storyCounter");
const storySparkButtons = [...document.querySelectorAll("[data-story-spark]")];
const ideaGenerateBtn = document.querySelector("#ideaGenerateBtn");
const ideaResults = document.querySelector("#ideaResults");
const ideaHeroName = document.querySelector("#ideaHeroName");

const projectTitle = document.querySelector("#projectTitle");
const projectLogline = document.querySelector("#projectLogline");
const studioStatus = document.querySelector("#studioStatus");
const titleInput = document.querySelector("#titleInput");
const loglineInput = document.querySelector("#loglineInput");
const styleInput = document.querySelector("#styleInput");
const pagesDeck = document.querySelector("#pagesDeck");
const pagesDeckHint = document.querySelector("#pagesDeckHint");
const deckSaveChip = document.querySelector("#deckSaveChip");
const deckPosLabel = document.querySelector("#deckPosLabel");
const deckDraftCta = document.querySelector("#deckDraftCta");
const draftStoryBtn = document.querySelector("#draftStoryBtn");
const redraftStoryBtn = document.querySelector("#redraftStoryBtn");
const deckActionBar = document.querySelector("#deckActionBar");
const deckViewport = document.querySelector("#deckViewport");
const deckTrack = document.querySelector("#deckTrack");
const deckPrevBtn = document.querySelector("#deckPrevBtn");
const deckNextBtn = document.querySelector("#deckNextBtn");
const deckDots = document.querySelector("#deckDots");
const deckFoot = document.querySelector("#deckFoot");
const deckAddPageBtn = document.querySelector("#deckAddPageBtn");
const deckCheckBtn = document.querySelector("#deckCheckBtn");
const deckCheckResults = document.querySelector("#deckCheckResults");
const deckScriptLink = document.querySelector("#deckScriptLink");
const deckOverviewBtn = document.querySelector("#deckOverviewBtn");
const deckOverviewModal = document.querySelector("#deckOverviewModal");
const deckOverviewClose = document.querySelector("#deckOverviewClose");
const deckOverviewGrid = document.querySelector("#deckOverviewGrid");
const deckOverviewStats = document.querySelector("#deckOverviewStats");
const downloadLink = document.querySelector("#downloadLink");
const toast = document.querySelector("#toast");
const appAnnouncer = document.querySelector("#appAnnouncer");
const wizardNextNote = document.querySelector("#wizardNextNote");

const restartModal = document.querySelector("#restartModal");
const restartModalCancel = document.querySelector("#restartModalCancel");
const restartModalConfirm = document.querySelector("#restartModalConfirm");

const STORY_SEED_LIMIT = 1200;
const IDEA_BATCH_SIZE = 4;

let page = 0;
let project = null;
let series = null;
let pendingTemplate = {};
let ideaBatch = 0;

const seriesChapterBar = document.querySelector("#seriesChapterBar");
const seriesChapterStrip = document.querySelector("#seriesChapterStrip");
const nextChapterCard = document.querySelector("#nextChapterCard");
const nextChapterSeed = document.querySelector("#nextChapterSeed");
const nextChapterTitle = document.querySelector("#nextChapterTitle");
const nextChapterBtn = document.querySelector("#nextChapterBtn");
const projectEyebrow = document.querySelector("#projectEyebrow");
const CHAPTER_STORY_PAGES = 10; // standard chapter: 10 story pages + 3 bookends

const dashboard = document.querySelector("#dashboard");
const seriesGrid = document.querySelector("#seriesGrid");
const dashboardEmpty = document.querySelector("#dashboardEmpty");
const dashboardHeading = document.querySelector("#dashboardHeading");
const dashboardNewSeriesBtn = document.querySelector("#dashboardNewSeriesBtn");
const dashboardEmptyStartBtn = document.querySelector("#dashboardEmptyStartBtn");
const navMySeriesLink = document.querySelector("#navMySeriesLink");
const studioMySeriesBtn = document.querySelector("#studioMySeriesBtn");
const MY_SERIES_KEY = "selfcomic_my_series";
let dashboardSeriesCache = [];

const analyticsSessionId = getAnalyticsSessionId();

const wizardNextMessages = [
  ["Next", "Pick the format and tone. The uploaded reference handles the visual identity."],
  ["Next", "Choose the big creative direction. Point of view is optional."],
  ["Next", "Write one sentence or keep clicking for fresh ideas until one feels right."],
  ["Next", "Pick the rendering style. Clean manga and premium comic both work with the same checkout flow."],
  ["What happens next", "We generate the storyboard, then a free cover preview. Checkout only appears after the preview path is ready."],
];

function getAnalyticsSessionId() {
  const key = "selfcomic_analytics_session";
  try {
    const existing = window.localStorage.getItem(key);
    if (existing) return existing;
    const created = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    window.localStorage.setItem(key, created);
    return created;
  } catch {
    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }
}

function trackEvent(eventName, metadata = {}, options = {}) {
  const payload = {
    event_name: eventName,
    session_id: analyticsSessionId,
    project_id: options.projectId || project?.id || null,
    path: window.location.pathname,
    step: options.step || "",
    metadata,
  };
  fetch("/api/v1/analytics/events", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }).catch(() => {});
}

function showToast(message) {
  toast.textContent = typeof message === "string" ? message : formatErrorMessage(message);
  toast.classList.add("show");
  announce(toast.textContent);
  window.clearTimeout(showToast.timer);
  showToast.timer = window.setTimeout(() => toast.classList.remove("show"), 3600);
}

function announce(message) {
  if (!appAnnouncer) return;
  appAnnouncer.textContent = "";
  window.setTimeout(() => {
    appAnnouncer.textContent = message;
  }, 20);
}

function showView(name) {
  landing.classList.toggle("hidden", name !== "landing");
  wizard.classList.toggle("hidden", name !== "wizard");
  studio.classList.toggle("hidden", name !== "studio");
  dashboard?.classList.toggle("hidden", name !== "dashboard");
  window.scrollTo({ top: 0, behavior: "auto" });
  renderIcons();
  window.requestAnimationFrame(() => {
    if (name === "wizard") {
      pages[page]?.querySelector("h1")?.focus?.({ preventScroll: true });
    } else if (name === "studio") {
      projectTitle?.focus?.({ preventScroll: true });
    } else if (name === "dashboard") {
      dashboardHeading?.focus?.({ preventScroll: true });
    }
  });
}

function setBusy(button, busy, label) {
  button.disabled = busy;
  if (busy) {
    if (!button.dataset.originalHtml) {
      button.dataset.originalHtml = button.innerHTML;
    }
    button.textContent = label;
  } else if (button.dataset.originalHtml) {
    button.innerHTML = button.dataset.originalHtml;
    delete button.dataset.originalHtml;
    renderIcons();
  }
}

function renderIcons() {
  if (window.lucide) {
    window.lucide.createIcons();
  }
}

function briefValue(name, fallback = "") {
  return form?.elements?.[name]?.value?.trim() || fallback;
}

function setFieldValue(name, value) {
  const field = form.elements[name];
  if (!field) return;
  field.value = value;
  field.dispatchEvent(new Event("input", { bubbles: true }));
}

function appendFieldValue(name, value) {
  const field = form.elements[name];
  if (!field) return;
  const existing = field.value.trim();
  field.value = existing ? `${existing}; ${value}` : value;
  field.dispatchEvent(new Event("input", { bubbles: true }));
}

function updateCharacterCounter() {
  const length = storySeedInput.value.length;
  storyCounter.textContent = `${length} / ${STORY_SEED_LIMIT}`;
}

function updateStep() {
  pages.forEach((item, index) => {
    const active = index === page;
    item.classList.toggle("active", active);
    item.setAttribute("aria-hidden", active ? "false" : "true");
    item.querySelector("h1")?.setAttribute("tabindex", "-1");
  });
  const percent = Math.round(((page + 1) / pages.length) * 100);
  wizardStepLabel.textContent = `Step ${page + 1} of ${pages.length}`;
  wizardPercent.textContent = `${percent}%`;
  wizardProgress.style.width = `${percent}%`;
  wizardProgress.parentElement?.setAttribute("aria-valuemax", String(pages.length));
  wizardProgress.parentElement?.setAttribute("aria-valuenow", String(page + 1));
  wizardProgress.parentElement?.setAttribute("aria-valuetext", `Step ${page + 1} of ${pages.length}`);
  backBtn.disabled = page === 0;
  nextBtn.classList.toggle("hidden", page === pages.length - 1);
  submitBtn.classList.toggle("hidden", page !== pages.length - 1);
  const subject = briefValue("subject_name", "them");
  if (relationshipHeading) relationshipHeading.textContent = `What is your role in ${subject}'s story?`;
  if (ideaHeroName) ideaHeroName.textContent = briefValue("subject_name", "your hero");
  if (wizardNextNote) {
    const [title, body] = wizardNextMessages[page] || wizardNextMessages[0];
    wizardNextNote.innerHTML = `<strong>${escapeHtml(title)}</strong>${escapeHtml(body)}`;
  }
  announce(`Step ${page + 1} of ${pages.length}. ${pages[page]?.querySelector("h1")?.textContent || ""}`);
  renderIcons();
}

function validatePage() {
  const activePage = pages[page];
  const fields = [...activePage.querySelectorAll("input, select, textarea")].filter((field) => field.type !== "hidden");
  if (!fields.every((field) => field.reportValidity())) {
    return false;
  }
  const requiredTarget = activePage.dataset.requiredTarget;
  if (requiredTarget && !briefValue(requiredTarget)) {
    showToast("Choose an option or add a custom answer to continue.");
    return false;
  }
  const requiredTargets = (activePage.dataset.requiredTargets || "")
    .split(",")
    .map((target) => target.trim())
    .filter(Boolean);
  const missingTarget = requiredTargets.find((target) => !briefValue(target));
  if (missingTarget) {
    const friendlyNames = { genre: "format", tone: "ending feeling", art_style: "art style" };
    showToast(`Choose a ${friendlyNames[missingTarget] || "required option"} to continue.`);
    return false;
  }
  return true;
}

function validateCompleteBrief() {
  const checks = [
    { page: 0, ok: briefValue("subject_name").length > 0, message: "Add the main character name." },
    { page: 0, ok: referenceInput.files.length > 0, message: "Upload at least one clear character reference image." },
    { page: 1, ok: briefValue("genre").length > 0, message: "Choose manga, comic, or a custom format." },
    { page: 1, ok: briefValue("tone").length > 0, message: "Choose an ending feeling or add a custom tone." },
    { page: 2, ok: briefValue("story_seed").length >= 8, message: "Add one quick sentence for the story idea." },
    { page: 3, ok: briefValue("art_style").length > 0, message: "Choose an art style or add a custom style." },
    { page: 4, ok: Boolean(form.elements.consent_confirmed?.checked), message: "Confirm you have permission to use the likeness or character reference." },
  ];
  const failed = checks.find((check) => !check.ok);
  if (failed) {
    page = failed.page;
    updateStep();
    showView("wizard");
    showToast(failed.message);
    return false;
  }
  return true;
}

function goNext(fromOption = false) {
  if (!validatePage()) return;
  trackEvent("wizard_step_completed", { step_index: page + 1 }, { step: `step_${page + 1}` });
  page = Math.min(page + 1, pages.length - 1);
  updateStep();
  pages[page]?.querySelector("h1")?.focus?.({ preventScroll: true });
  if (!fromOption) {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}

function seriesPayload() {
  const data = new FormData(form);
  const fields = Object.fromEntries(data.entries());
  const protagonist = (fields.subject_name || "").trim();
  return {
    title: (fields.comic_title || "").trim() || `${protagonist}'s Series`,
    description: (fields.story_seed || "").trim(),
    protagonist_name: protagonist,
    character_description: fields.character_description || "",
    genre: fields.genre,
    tone: fields.tone,
    art_style: fields.art_style,
    style_id: fields.style_id || "",
    language: fields.language || "English",
    creator_name: fields.creator_name || "",
    delivery_email: fields.delivery_email || null,
    // Series story bible (B1): durable premise/arc injected into every chapter.
    // Optional in the wizard; primarily authored/edited from the series board.
    story_bible: (fields.story_bible || "").trim(),
    consent_confirmed: Boolean(data.get("consent_confirmed")),
  };
}

function chapterPayload() {
  const data = new FormData(form);
  const fields = Object.fromEntries(data.entries());
  return {
    story_seed: fields.story_seed,
    chapter_title: "",
    page_count: CHAPTER_STORY_PAGES,
    must_include: fields.must_include || "",
    avoid: fields.avoid || "",
  };
}

async function api(path, options = {}) {
  const response = await fetch(path, {
    headers: options.body instanceof FormData ? options.headers || {} : { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(formatApiError(body, response.status));
    err.status = response.status;
    err.body = body;
    throw err;
  }
  return body;
}

function formatApiError(body, status) {
  // Standard error envelope: {error: {code, message, detail}}.
  if (body && body.error && typeof body.error === "object") {
    const env = body.error;
    if (Array.isArray(env.detail)) return formatApiError({ detail: env.detail }, status);
    return formatErrorMessage(env.message || env.detail || `Request failed (${status}).`);
  }
  if (Array.isArray(body?.detail)) {
    const messages = body.detail.map((item) => {
      const loc = Array.isArray(item.loc)
        ? item.loc.filter((part) => !["body", "brief"].includes(part)).join(".")
        : "";
      const msg = item.msg || "Invalid value";
      return loc ? `${loc}: ${msg}` : msg;
    });
    return messages.join("; ");
  }
  return formatErrorMessage(body?.detail || body?.message || body?.error || `Request failed (${status}).`);
}

function formatErrorMessage(value) {
  if (typeof value === "string") return value;
  if (Array.isArray(value)) return value.map(formatErrorMessage).join("; ");
  if (value && typeof value === "object") {
    if (value.msg) return value.msg;
    if (value.detail) return formatErrorMessage(value.detail);
    try {
      return JSON.stringify(value);
    } catch {
      return "Something went wrong.";
    }
  }
  return "Something went wrong.";
}

function hydrateProject(nextProject) {
  if (project?.id && nextProject?.id === project.id) {
    const mergedReferences = [];
    [...(nextProject.reference_urls || []), ...(project.reference_urls || [])].forEach((url) => {
      if (url && !mergedReferences.includes(url)) mergedReferences.push(url);
    });
    nextProject = { ...nextProject, reference_urls: mergedReferences };
  }
  project = nextProject;
  if (projectEyebrow) {
    projectEyebrow.textContent =
      project.series_id && project.chapter_number
        ? `${project.brief.series_title || "Your Series"} — Chapter ${project.chapter_number}`
        : "Your Comic";
  }
  projectTitle.textContent = project.title || `${project.brief.subject_name}'s comic`;
  projectLogline.textContent = project.logline || "Storyboard not generated yet.";
  titleInput.value = project.title || "";
  loglineInput.value = project.logline || "";
  styleInput.value = project.visual_style_prompt || "";
  renderPagesDeck();
  renderStatus();
  syncSeries();
  if (downloadLink) {
    if (project.pdf_url) {
      downloadLink.href = assetUrl(project.pdf_url);
      downloadLink.classList.remove("hidden");
    } else {
      downloadLink.classList.add("hidden");
    }
  }
  syncProjectUrl();
}

function syncProjectUrl() {
  if (!project?.id) return;
  const params = new URLSearchParams(window.location.search);
  if (params.get("project") === project.id && !params.has("view") && !params.has("series")) return;
  params.set("project", project.id);
  params.delete("view");
  params.delete("series");
  const next = `${window.location.pathname}?${params.toString()}`;
  try {
    window.history.replaceState(null, "", next);
  } catch {}
}

function clearProjectUrl() {
  const params = new URLSearchParams(window.location.search);
  if (!params.has("project") && !params.has("paid") && !params.has("session_id") && !params.has("view") && !params.has("series")) return;
  try {
    window.history.replaceState(null, "", window.location.pathname);
  } catch {}
}

function renderStatus() {
  if (!studioStatus) return;
  if (!project) {
    studioStatus.textContent = "Drafting storyboard";
    return;
  }
  const total = project.pages?.length || 0;
  const approved = Math.min(project.approved_through || 0, total);
  if (project.pdf_url) {
    studioStatus.textContent = "Chapter complete";
  } else if ((project.full_assets?.length || 0) > 0 || approved > 0) {
    studioStatus.textContent = `Generating pages — ${approved} of ${total} approved`;
  } else if (project.story_drafted) {
    studioStatus.textContent = "Storyboard review";
  } else if (total) {
    studioStatus.textContent = "Drafting the storyboard";
  } else {
    studioStatus.textContent = "Drafting storyboard";
  }
}

// -- Chapter pages deck -------------------------------------------------------
// The deck IS the studio workspace: one swipeable card per page. The flow is
// guided and strictly sequential: review/edit the storyboard page by page,
// then generate page art one page at a time — approve, deny (regenerate), or
// edit (region redo + balloons in the page editor) — and approving a page lets
// the next one generate, anchored to the approved art and the character canon.

const DECK_PAGE_TYPE_LABELS = {
  title_splash: "Cover",
  story: "Story",
  character_profile: "Cast",
  the_end: "Closing",
  colophon: "Colophon",
};

const DECK_HINTS = {
  sketch: "These are placeholder beats. Draft the chapter script to review and edit every page.",
  review: "Review each page's plot, characters, and dialogue. Edit anything, then start generating.",
  guided: "Pages are drawn one at a time. Approve a page to unlock the next; deny to redraw; edit for region fixes and balloons.",
  built: "Chapter complete. Open any page in the editor to retouch art or balloons.",
};

let deckIndex = 0;
let deckSignature = "";
let deckLastMode = "";
let deckProjectId = null;
let deckDirty = false;
let deckSaveTimer = null;
let deckDrag = null;
let deckGenerating = 0;
let deckActionBusy = false;
// Forum share state for the built chapter (null = not yet fetched).
let deckForumPublished = null;
let deckForumProjectId = null;

function deckMode() {
  if (!project?.pages?.length) return "hidden";
  if (project.pdf_url) return "built";
  if ((project.full_assets?.length || 0) > 0 || (project.approved_through || 0) > 0) return "guided";
  if (!project.story_drafted) return "sketch";
  return "review";
}

function deckAssetFor(pageNumber) {
  return (
    (project?.full_assets || []).find((asset) => asset.page_number === pageNumber) ||
    (project?.preview_assets || []).find((asset) => asset.page_number === pageNumber) ||
    null
  );
}

function escapeRegExp(value) {
  return String(value || "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function pageCharacters(page) {
  const haystack = `${page.scene_title} ${page.setting} ${page.image_prompt} ${page.caption} ${page.dialogue}`.toLowerCase();
  const names = [];
  const protagonist = (project?.brief?.subject_name || "").trim();
  if (protagonist && new RegExp(`\\b${escapeRegExp(protagonist.toLowerCase())}\\b`).test(haystack)) {
    names.push(protagonist);
  }
  (project?.cast_canon || []).forEach((member) => {
    const name = (member.name || "").trim();
    if (!name || name.toLowerCase() === protagonist.toLowerCase()) return;
    if (new RegExp(`\\b${escapeRegExp(name.toLowerCase())}\\b`).test(haystack)) names.push(name);
  });
  return names;
}

function deckCharactersHtml(page) {
  const names = pageCharacters(page);
  if (!names.length) return "";
  return `<div class="deck-chips" aria-label="Characters on this page">
      <span class="deck-chips-label">Characters</span>
      ${names.map((name) => `<span class="deck-chip">${escapeHtml(name)}</span>`).join("")}
    </div>`;
}

function deckFieldsHtml(page) {
  const pageNumber = page.page_number;
  const isCover = page.page_type === "title_splash";
  const titleField = isCover
    ? `<label class="deck-field">Comic title
        <input type="text" maxlength="140" data-deck-title value="${escapeHtml(project?.title || "")}" />
      </label>
      <button type="button" class="ghost-btn deck-title-btn" data-deck-action="update-title"><i data-lucide="type"></i> Update title</button>`
    : "";
  const beatFields = isCover
    ? ""
    : `<label class="deck-field">Scene title
        <input type="text" maxlength="140" data-deck-field="scene_title" data-deck-page="${pageNumber}" value="${escapeHtml(page.scene_title || "")}" />
      </label>
      <label class="deck-field">Caption
        <textarea rows="2" maxlength="700" data-deck-field="caption" data-deck-page="${pageNumber}" data-soft="110" placeholder="Narration over the page">${escapeHtml(page.caption || "")}</textarea>
        <span class="deck-count" aria-hidden="true"></span>
      </label>
      <label class="deck-field">Dialogue
        <textarea rows="3" maxlength="700" data-deck-field="dialogue" data-deck-page="${pageNumber}" data-soft="85" placeholder='Spoken lines in quotes: "..."'>${escapeHtml(page.dialogue || "")}</textarea>
        <span class="deck-count" aria-hidden="true"></span>
      </label>
      <div class="deck-suggest">
        <button type="button" class="ghost-btn deck-suggest-btn" data-deck-action="suggest" data-deck-page="${pageNumber}">
          <i data-lucide="sparkles"></i> Suggest lines
        </button>
        <div class="deck-suggest-list" data-suggest-slot="${pageNumber}" hidden></div>
      </div>`;
  const pageTools =
    page.page_type === "story"
      ? `<div class="deck-page-tools">
          <button type="button" class="deck-move-btn" data-deck-action="move-page-up" data-deck-page="${pageNumber}" title="Move page earlier"><i data-lucide="arrow-up"></i> Move up</button>
          <button type="button" class="deck-move-btn" data-deck-action="move-page-down" data-deck-page="${pageNumber}" title="Move page later"><i data-lucide="arrow-down"></i> Move down</button>
          <button type="button" class="deck-move-btn" data-deck-action="duplicate-page" data-deck-page="${pageNumber}" title="Duplicate this page"><i data-lucide="copy"></i> Duplicate</button>
          <button type="button" class="deck-remove-btn" data-deck-action="remove-page" data-deck-page="${pageNumber}"><i data-lucide="trash-2"></i> Remove</button>
        </div>`
      : "";
  return `${titleField}${beatFields}
    <details class="deck-advanced">
      <summary>Art direction</summary>
      <textarea rows="4" maxlength="1800" data-deck-field="image_prompt" data-deck-page="${pageNumber}" placeholder="What the artist should draw on this page">${escapeHtml(page.image_prompt || "")}</textarea>
    </details>
    <details class="deck-advanced">
      <summary>Notes (private)</summary>
      <textarea rows="3" maxlength="2000" data-deck-field="notes" data-deck-page="${pageNumber}" placeholder="Planning notes just for you — never drawn or printed">${escapeHtml(page.notes || "")}</textarea>
    </details>
    ${pageTools}`;
}

// Live length counter for a caption/dialogue field: shows the character count
// and a soft "over the balloon" warning past data-soft (a hint, not a hard cap).
function updateDeckCount(field) {
  const soft = Number(field.dataset.soft || 0);
  if (!soft) return;
  const counter = field.nextElementSibling;
  if (!counter || !counter.classList.contains("deck-count")) return;
  const len = (field.value || "").length;
  counter.textContent = len > soft ? `${len} — may overflow` : `${len}`;
  counter.classList.toggle("over", len > soft);
}

function deckBeatSummaryHtml(page) {
  return `
    ${page.caption ? `<p class="deck-text"><strong>Caption</strong>${escapeHtml(page.caption)}</p>` : ""}
    ${page.dialogue ? `<p class="deck-text"><strong>Dialogue</strong>${escapeHtml(page.dialogue)}</p>` : ""}`;
}

function deckCardHtml(page, mode) {
  const pageNumber = page.page_number;
  const asset = deckAssetFor(pageNumber);
  const typeLabel = DECK_PAGE_TYPE_LABELS[page.page_type] || "Story";
  const isColophon = page.page_type === "colophon";
  const approvedThrough = project?.approved_through || 0;
  const currentPage = approvedThrough + 1;
  const generating = deckGenerating === pageNumber;
  const approved = mode === "guided" && pageNumber <= approvedThrough;

  const art = asset?.url && !generating
    ? `<img src="${assetUrl(asset.url)}" alt="Page ${pageNumber} art" draggable="false" loading="lazy" />`
    : `<div class="deck-art-placeholder">
        ${
          generating
            ? `<span class="deck-spinner" aria-hidden="true"></span>
              <strong>Illustrating page ${pageNumber}...</strong>
              <small>Anchored to your character canon${pageNumber > 1 ? " and the approved pages" : ""}</small>`
            : `<i data-lucide="${isColophon ? "book-marked" : "image"}"></i>
              <strong>${escapeHtml(page.scene_title || `Page ${pageNumber}`)}</strong>
              ${page.setting ? `<span>${escapeHtml(page.setting)}</span>` : ""}
              ${page.mood ? `<em>${escapeHtml(page.mood)}</em>` : ""}
              <small>Not drawn yet</small>`
        }
      </div>`;

  let body = "";
  if (mode === "sketch") {
    body = isColophon
      ? `<p class="deck-note">Auto-generated credits page.</p>`
      : `${deckBeatSummaryHtml(page)}
        <p class="deck-note"><i data-lucide="pen-line"></i> Placeholder beat — draft the chapter script above to review and edit this page.</p>`;
  } else if (mode === "review") {
    body = isColophon
      ? `<p class="deck-note">Auto-generated credits page — nothing to review here.</p>`
      : `${deckCharactersHtml(page)}${deckFieldsHtml(page)}`;
  } else if (mode === "built") {
    body = `
      ${deckBeatSummaryHtml(page)}
      ${
        isColophon
          ? `<p class="deck-note">Auto-generated credits page.</p>`
          : `<a class="cta-btn deck-edit-link" href="/editor?project=${project.id}&page=${pageNumber}"><i data-lucide="brush"></i> Edit art &amp; balloons</a>`
      }`;
  } else if (approved) {
    body = `
      ${deckBeatSummaryHtml(page)}
      <a class="ghost-btn deck-edit-link" href="/editor?project=${project.id}&page=${pageNumber}"><i data-lucide="brush"></i> Open in editor</a>`;
  } else if (pageNumber === currentPage) {
    const disabled = generating || deckActionBusy ? " disabled" : "";
    if (asset && !generating) {
      body = `
        ${deckCharactersHtml(page)}
        <div class="deck-decision">
          <button type="button" class="cta-btn gold" data-deck-action="approve" data-deck-page="${pageNumber}"${disabled}><i data-lucide="check"></i> Approve &amp; continue</button>
          <button type="button" class="ghost-btn" data-deck-action="regenerate" data-deck-page="${pageNumber}"${disabled}><i data-lucide="refresh-cw"></i> Deny &amp; redraw</button>
          <a class="ghost-btn" href="/editor?project=${project.id}&page=${pageNumber}"><i data-lucide="lasso"></i> Edit regions &amp; balloons</a>
        </div>
        <p class="deck-note"><i data-lucide="info"></i> Tweak the text below and hit "Deny &amp; redraw" to steer the art. Region fixes (circle an area, add/remove balloons) live in the editor.</p>
        ${deckFieldsHtml(page)}`;
    } else {
      body = `
        ${deckCharactersHtml(page)}
        ${
          generating
            ? `<p class="deck-note"><i data-lucide="timer"></i> Drawing this page now — hang tight.</p>`
            : `<div class="deck-decision">
                <button type="button" class="cta-btn gold" data-deck-action="generate" data-deck-page="${pageNumber}"${disabled}><i data-lucide="sparkles"></i> Generate this page</button>
              </div>`
        }
        ${deckFieldsHtml(page)}`;
    }
  } else {
    body = isColophon
      ? `<p class="deck-note">Auto-generated credits page — added automatically when you finish.</p>`
      : `
      ${deckCharactersHtml(page)}
      <p class="deck-note"><i data-lucide="lock"></i> Unlocks after page ${pageNumber - 1} is approved. You can still edit the beat now.</p>
      ${deckFieldsHtml(page)}`;
  }

  const badges = `
    <span class="deck-page-badge">Page ${pageNumber} &middot; ${typeLabel}</span>
    ${approved ? `<span class="deck-approved-badge"><i data-lucide="check"></i> Approved</span>` : ""}`;

  const editable = ["review", "guided"].includes(mode) && !isColophon;
  return `
    <article class="deck-card${editable ? " editable" : ""}${generating ? " generating" : ""}" data-deck-card="${pageNumber}">
      <div class="deck-card-art">${art}${badges}</div>
      <div class="deck-card-body">${body}</div>
    </article>`;
}

function renderDeckActionBar(mode) {
  if (!deckActionBar) return;
  const total = project?.pages?.length || 0;
  const approvedThrough = Math.min(project?.approved_through || 0, total);
  let html = "";
  if (mode === "review") {
    html = `
      <div class="deck-bar-copy">
        <strong>Storyboard ready for review</strong>
        <span>Approve the storyboard to start drawing page 1. Pages generate one at a time, and each waits for your approval.</span>
      </div>
      <button type="button" class="cta-btn gold" data-deck-action="start"${deckActionBusy ? " disabled" : ""}><i data-lucide="play"></i> Approve storyboard &amp; generate page 1</button>`;
  } else if (mode === "guided") {
    const percent = total ? Math.round((approvedThrough / total) * 100) : 0;
    html = `
      <div class="deck-bar-copy">
        <strong>${approvedThrough} of ${total} pages approved</strong>
        <div class="deck-bar-progress"><span style="width:${percent}%"></span></div>
      </div>
      <button type="button" class="ghost-btn" data-deck-action="finish"${approvedThrough < 1 || deckActionBusy || deckGenerating ? " disabled" : ""}><i data-lucide="flag"></i> Finish comic here</button>`;
  } else if (mode === "built") {
    ensureDeckForumStatus();
    const forumBtn = deckForumPublished === null
      ? `<button type="button" class="ghost-btn" data-deck-action="forum" disabled><i data-lucide="loader"></i> Checking forum…</button>`
      : deckForumPublished
        ? `<button type="button" class="ghost-btn deck-forum-on" data-deck-action="forum"><i data-lucide="check"></i> On the forum — remove</button>`
        : `<button type="button" class="cta-btn gold" data-deck-action="forum"><i data-lucide="globe"></i> Post to forum</button>`;
    html = `
      <div class="deck-bar-copy">
        <strong>Chapter complete — ${project?.full_assets?.length || 0} pages</strong>
        <span>Download the PDF below, share it on the community forum, or start the next chapter.</span>
      </div>
      ${forumBtn}`;
  }
  deckActionBar.innerHTML = html;
  deckActionBar.classList.toggle("hidden", !html);
  renderIcons();
}

async function ensureDeckForumStatus() {
  // Fetch the forum-share state once per built project; re-render when known.
  if (!project || !project.pdf_url) return;
  if (deckForumProjectId === project.id) return;
  deckForumProjectId = project.id;
  deckForumPublished = null;
  try {
    const res = await fetch(`/api/v1/projects/${project.id}/forum`);
    if (res.ok) deckForumPublished = Boolean((await res.json()).published);
    else deckForumPublished = false;
  } catch {
    deckForumPublished = false;
  }
  if (deckMode() === "built") renderDeckActionBar("built");
}

async function toggleDeckForum(button) {
  if (!project) return;
  button.disabled = true;
  try {
    if (deckForumPublished) {
      const res = await fetch(`/api/v1/projects/${project.id}/forum`, { method: "DELETE" });
      if (!res.ok && res.status !== 204) throw new Error("Could not remove from forum.");
      deckForumPublished = false;
    } else {
      const res = await fetch(`/api/v1/projects/${project.id}/forum`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ blurb: "" }),
      });
      if (!res.ok) throw new Error((await res.json()).detail || "Could not post to the forum.");
      deckForumPublished = true;
    }
  } catch (err) {
    window.alert(err.message);
  } finally {
    renderDeckActionBar("built");
  }
}

function renderPagesDeck(force = false) {
  if (!pagesDeck) return;
  const mode = deckMode();
  if (mode === "hidden") {
    pagesDeck.classList.add("hidden");
    deckSignature = "";
    deckLastMode = "";
    return;
  }
  const signature = JSON.stringify([
    mode,
    project.id,
    project.approved_through || 0,
    deckGenerating,
    deckActionBusy,
    project.title || "",
    project.pages.map((page) => [page.page_number, page.scene_title, page.caption, page.dialogue, page.image_prompt, page.page_type]),
    (project.full_assets || []).map((asset) => [asset.page_number, asset.url]),
  ]);
  // Rebuilding the DOM drops focus and swipe state, so skip when nothing
  // changed, and never rebuild under the user's cursor while they type.
  const typingInDeck = deckTrack.contains(document.activeElement);
  if (!force && signature === deckSignature) return;
  if (!force && typingInDeck && mode === deckLastMode && project.id === deckProjectId) {
    deckSignature = signature;
    return;
  }
  deckSignature = signature;
  const projectChanged = project.id !== deckProjectId;
  deckLastMode = mode;
  deckProjectId = project.id;

  pagesDeck.classList.remove("hidden");
  pagesDeck.dataset.mode = mode;
  if (pagesDeckHint) pagesDeckHint.textContent = DECK_HINTS[mode] || "";
  deckDraftCta?.classList.toggle("hidden", mode !== "sketch");
  deckFoot?.classList.toggle("hidden", mode === "sketch");
  if (deckScriptLink) {
    const hasPages = (project.pages || []).length > 0;
    deckScriptLink.classList.toggle("hidden", mode === "sketch" || !hasPages);
    if (hasPages) deckScriptLink.href = `/api/v1/projects/${project.id}/script.md`;
  }
  redraftStoryBtn?.classList.toggle("hidden", mode !== "review");
  deckCheckBtn?.classList.toggle("hidden", !["review", "guided"].includes(mode));
  deckAddPageBtn?.classList.toggle("hidden", !["review", "guided"].includes(mode));
  if (deckSaveChip) deckSaveChip.classList.toggle("hidden", !["review", "guided"].includes(mode));
  renderDeckActionBar(mode);

  const sorted = [...project.pages].sort((a, b) => a.page_number - b.page_number);
  deckTrack.innerHTML = sorted.map((page) => deckCardHtml(page, mode)).join("");
  deckTrack.querySelectorAll("[data-soft]").forEach(updateDeckCount);
  deckDots.innerHTML = sorted
    .map((page, index) => {
      const state = mode === "guided" ? (page.page_number <= (project.approved_through || 0) ? " done" : page.page_number === (project.approved_through || 0) + 1 ? " current" : "") : "";
      return `<button type="button" class="deck-dot${state}" data-deck-dot="${index}" aria-label="Go to page ${page.page_number}"></button>`;
    })
    .join("");
  if (projectChanged) {
    deckIndex = mode === "guided" ? Math.min(project.approved_through || 0, sorted.length - 1) : 0;
  }
  deckIndex = Math.min(deckIndex, sorted.length - 1);
  updateDeckPosition(false);
  setDeckChip(deckDirty ? "dirty" : "idle");
  renderIcons();
}

function updateDeckPosition(animate = true) {
  if (!deckTrack) return;
  deckTrack.classList.toggle("no-anim", !animate);
  deckTrack.style.transform = `translateX(${-deckIndex * 100}%)`;
  const count = deckTrack.children.length;
  if (deckPrevBtn) deckPrevBtn.disabled = deckIndex <= 0;
  if (deckNextBtn) deckNextBtn.disabled = deckIndex >= count - 1;
  if (deckPosLabel) deckPosLabel.textContent = count ? `Page ${deckIndex + 1} of ${count}` : "";
  [...deckDots.children].forEach((dot, index) => dot.classList.toggle("active", index === deckIndex));
}

function goToDeckPage(index) {
  const count = deckTrack?.children.length || 0;
  if (!count) return;
  deckIndex = Math.max(0, Math.min(index, count - 1));
  updateDeckPosition(true);
}

function setDeckChip(status) {
  if (!deckSaveChip) return;
  deckSaveChip.dataset.status = status;
  deckSaveChip.textContent =
    { idle: "Saved", dirty: "Unsaved edits", saving: "Saving...", saved: "Saved", error: "Save failed" }[status] || "Saved";
}

async function saveDeckEdits() {
  if (!project || !deckDirty) return project;
  window.clearTimeout(deckSaveTimer);
  if (!["review", "guided"].includes(deckMode())) {
    deckDirty = false;
    return project;
  }
  const payload = {
    title: project.title || `${project.brief?.subject_name || "My"} comic`,
    logline: (project.logline || "").trim() || "A new chapter in this series.",
    visual_style_prompt:
      (project.visual_style_prompt || "").trim() || "Clean modern comic style with crisp inks and rich color.",
    pages: project.pages.map((page) => ({
      ...page,
      scene_title: (page.scene_title || "").trim() || `Page ${page.page_number}`,
    })),
  };
  deckDirty = false;
  setDeckChip("saving");
  try {
    const saved = await api(`/api/v1/projects/${project.id}/script`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
    // Update quietly — rebuilding the deck here would drop the user's focus.
    project.updated_at = saved.updated_at;
    project.story_drafted = saved.story_drafted;
    project.title = saved.title;
    setDeckChip("saved");
  } catch (error) {
    deckDirty = true;
    setDeckChip("error");
    showToast(error.message);
  }
  return project;
}

async function draftStoryPages(force = false) {
  if (!project) return;
  if (force && !window.confirm("Re-draft every page with AI? Your current page text will be replaced.")) return;
  const button = force ? redraftStoryBtn : draftStoryBtn;
  if (button) setBusy(button, true, "Writing script...");
  try {
    const drafted = await api(`/api/v1/projects/${project.id}/draft-story${force ? "?force=true" : ""}`, { method: "POST" });
    deckDirty = false;
    hydrateProject(drafted);
    showToast("Chapter script drafted. Review each page, then start generating.");
  } catch (error) {
    showToast(error.message);
  } finally {
    if (button) setBusy(button, false);
  }
}

// -- Add a page to the storyboard ---------------------------------------------

async function addDeckPage() {
  if (!project) return;
  await saveDeckEdits();
  setBusy(deckAddPageBtn, true, "Adding...");
  try {
    const updated = await api(`/api/v1/projects/${project.id}/pages/append`, { method: "POST" });
    deckDirty = false;
    hydrateProject(updated);
    // Jump to the newly added story page (highest-numbered story page).
    const story = (project.pages || []).filter((p) => p.page_type === "story");
    if (story.length) {
      const newest = Math.max(...story.map((p) => p.page_number));
      const sorted = [...project.pages].sort((a, b) => a.page_number - b.page_number);
      const idx = sorted.findIndex((p) => p.page_number === newest);
      if (idx >= 0) goToDeckPage(idx);
    }
    showToast("Page added — edit its beat, then generate when ready.");
  } catch (error) {
    showToast(error.message);
  } finally {
    setBusy(deckAddPageBtn, false);
  }
}

async function moveDeckPage(pageNumber, direction) {
  if (!project) return;
  await saveDeckEdits();
  try {
    const updated = await api(
      `/api/v1/projects/${project.id}/pages/${pageNumber}/move?direction=${direction}`,
      { method: "POST" },
    );
    deckDirty = false;
    // The page's new number is its old ±1; follow it so the deck stays on it.
    const targetNumber = direction === "up" ? pageNumber - 1 : pageNumber + 1;
    hydrateProject(updated);
    const sorted = [...project.pages].sort((a, b) => a.page_number - b.page_number);
    const idx = sorted.findIndex((p) => p.page_number === targetNumber);
    if (idx >= 0) goToDeckPage(idx);
  } catch (error) {
    showToast(error.message);
  }
}

async function duplicateDeckPage(pageNumber) {
  if (!project) return;
  await saveDeckEdits();
  try {
    const updated = await api(`/api/v1/projects/${project.id}/pages/${pageNumber}/duplicate`, {
      method: "POST",
    });
    deckDirty = false;
    hydrateProject(updated);
    const sorted = [...project.pages].sort((a, b) => a.page_number - b.page_number);
    const idx = sorted.findIndex((p) => p.page_number === pageNumber + 1);
    if (idx >= 0) goToDeckPage(idx);
    showToast("Page duplicated — edit the copy as you like.");
  } catch (error) {
    showToast(error.message);
  }
}

async function removeDeckPage(pageNumber) {
  if (!project) return;
  if (!window.confirm(`Remove page ${pageNumber}? The pages after it shift up by one.`)) return;
  await saveDeckEdits();
  try {
    const updated = await api(`/api/v1/projects/${project.id}/pages/${pageNumber}`, {
      method: "DELETE",
    });
    deckDirty = false;
    hydrateProject(updated);
    showToast("Page removed.");
  } catch (error) {
    showToast(error.message);
  }
}

// -- Storyboard continuity check ----------------------------------------------

async function checkStoryboard() {
  if (!project || !deckCheckResults) return;
  setBusy(deckCheckBtn, true, "Checking...");
  try {
    const res = await api(`/api/v1/projects/${project.id}/storyboard-check`);
    const findings = res.findings || [];
    if (!findings.length) {
      deckCheckResults.innerHTML =
        `<p class="deck-check-ok"><i data-lucide="check-circle"></i> Storyboard looks clean — no issues found.</p>`;
    } else {
      const items = findings
        .map((f) => {
          const where = f.page ? `Page ${f.page}` : "Storyboard";
          return `<li class="deck-check-item deck-check-${escapeHtml(f.level)}">
              <button type="button" class="deck-check-jump" data-check-page="${escapeHtml(String(f.page || 0))}">${escapeHtml(where)}</button>
              <span>${escapeHtml(f.message)}</span>
            </li>`;
        })
        .join("");
      deckCheckResults.innerHTML =
        `<p class="deck-check-head">${findings.length} note${findings.length === 1 ? "" : "s"} to review:</p><ul class="deck-check-list">${items}</ul>`;
    }
    deckCheckResults.classList.remove("hidden");
    renderIcons();
  } catch (error) {
    showToast(error.message);
  } finally {
    setBusy(deckCheckBtn, false);
  }
}

// -- AI writing assist: per-page line suggestions -----------------------------

const deckSuggestSeeds = {};

async function suggestDeckLines(pageNumber, button) {
  if (!project) return;
  const slot = pagesDeck.querySelector(`[data-suggest-slot="${pageNumber}"]`);
  // Increment a per-page seed so each click surfaces fresh options.
  const seed = (deckSuggestSeeds[pageNumber] = (deckSuggestSeeds[pageNumber] || 0) + 1);
  setBusy(button, true, "Thinking...");
  try {
    const res = await api(
      `/api/v1/projects/${project.id}/pages/${pageNumber}/suggest?count=3&seed=${seed}`,
      { method: "POST" },
    );
    const options = res.suggestions || [];
    if (slot) {
      if (!options.length) {
        slot.innerHTML = `<p class="deck-note">No suggestions right now — edit the beat and try again.</p>`;
      } else {
        slot.innerHTML = options
          .map((opt) => {
            const cap = opt.caption || "";
            const dlg = opt.dialogue || "";
            const attrs = `data-deck-page="${pageNumber}" data-sugg-caption="${escapeHtml(cap)}" data-sugg-dialogue="${escapeHtml(dlg)}"`;
            const btn = (mode, label) =>
              `<button type="button" class="deck-suggest-apply" data-deck-action="apply-suggestion" data-apply-mode="${mode}" ${attrs}>${label}</button>`;
            const actions = [
              cap ? btn("caption", "Use caption") : "",
              dlg ? btn("dialogue", "Use dialogue") : "",
              cap && dlg ? btn("both", "Use both") : "",
            ].join("");
            return `<div class="deck-suggest-item">
                ${cap ? `<span class="deck-suggest-cap">${escapeHtml(cap)}</span>` : ""}
                ${dlg ? `<span class="deck-suggest-dlg">&ldquo;${escapeHtml(dlg)}&rdquo;</span>` : ""}
                <span class="deck-suggest-actions">${actions}</span>
              </div>`;
          })
          .join("");
      }
      slot.hidden = false;
    }
  } catch (error) {
    showToast(error.message);
  } finally {
    setBusy(button, false);
  }
}

function applyDeckSuggestion(button) {
  if (!project) return;
  const pageNumber = Number(button.dataset.deckPage || 0);
  const target = project.pages.find((page) => page.page_number === pageNumber);
  if (!target) return;
  const mode = button.dataset.applyMode || "both";
  const caption = button.dataset.suggCaption || "";
  const dialogue = button.dataset.suggDialogue || "";
  // Reflect in the visible textareas without rebuilding the deck (keeps scroll/focus).
  const card = button.closest(".deck-card") || pagesDeck;
  const capField = card.querySelector(`[data-deck-field="caption"][data-deck-page="${pageNumber}"]`);
  const dlgField = card.querySelector(`[data-deck-field="dialogue"][data-deck-page="${pageNumber}"]`);
  if (mode === "caption" || mode === "both") {
    target.caption = caption;
    if (capField) capField.value = caption;
  }
  if (mode === "dialogue" || mode === "both") {
    target.dialogue = dialogue;
    if (dlgField) dlgField.value = dialogue;
  }
  deckDirty = true;
  setDeckChip("dirty");
  window.clearTimeout(deckSaveTimer);
  deckSaveTimer = window.setTimeout(saveDeckEdits, 600);
  showToast("Applied — tweak or keep it, we'll save automatically.");
}

// -- Guided page-by-page generation -------------------------------------------

async function guidedGenerate(pageNumber) {
  if (!project || deckGenerating) return;
  await saveDeckEdits();
  try {
    await ensureReferenceUploads();
  } catch {}
  deckGenerating = pageNumber;
  renderPagesDeck(true);
  goToDeckPage(pageNumber - 1);
  renderStatus();
  try {
    const updated = await api(`/api/v1/projects/${project.id}/guided/pages/${pageNumber}/generate`, { method: "POST" });
    deckGenerating = 0;
    hydrateProject(updated);
    goToDeckPage(pageNumber - 1);
    announce(`Page ${pageNumber} art is ready for review.`);
    refreshCredits();  // a generation just spent a credit
  } catch (error) {
    deckGenerating = 0;
    renderPagesDeck(true);
    trackEvent("generation_error_seen", { stage: "guided_page", error_type: error.name || "Error" });
    if (error.status === 402) {
      showBuyCreditsModal("You're out of credits — top up to keep generating this chapter.");
    } else {
      showToast(error.message);
    }
  }
}

async function guidedApprove(pageNumber) {
  if (!project || deckActionBusy || deckGenerating) return;
  deckActionBusy = true;
  renderPagesDeck(true);
  try {
    const updated = await api(`/api/v1/projects/${project.id}/guided/pages/${pageNumber}/approve`, { method: "POST" });
    deckActionBusy = false;
    hydrateProject(updated);
    if (updated.pdf_url) {
      trackEvent("full_build_completed", { page_count: updated.full_assets?.length || 0, has_pdf: true });
      showToast("Chapter complete! Your PDF is ready to download.");
      return;
    }
    const next = (updated.approved_through || 0) + 1;
    if (next <= (updated.pages?.length || 0)) {
      showToast(`Page ${pageNumber} approved. Drawing page ${next}...`);
      await guidedGenerate(next);
    }
  } catch (error) {
    deckActionBusy = false;
    renderPagesDeck(true);
    showToast(error.message);
  }
}

async function guidedFinish() {
  if (!project || deckActionBusy || deckGenerating) return;
  const approved = project.approved_through || 0;
  if (!window.confirm(`Finish the comic with ${approved} approved page${approved === 1 ? "" : "s"}? Pages you haven't approved are left out.`)) return;
  deckActionBusy = true;
  renderPagesDeck(true);
  try {
    const updated = await api(`/api/v1/projects/${project.id}/guided/finish`, { method: "POST" });
    deckActionBusy = false;
    hydrateProject(updated);
    trackEvent("full_build_completed", { page_count: updated.full_assets?.length || 0, has_pdf: Boolean(updated.pdf_url), early: true });
    showToast("Comic assembled. Download your PDF below.");
  } catch (error) {
    deckActionBusy = false;
    renderPagesDeck(true);
    showToast(error.message);
  }
}

async function startGuidedGeneration() {
  if (!project) return;
  trackEvent("full_build_started", { page_count: project.pages?.length || 0, source: "guided" });
  await guidedGenerate(1);
}

async function updateDeckTitle(button) {
  if (!project?.id) return;
  const field = deckTrack.querySelector("[data-deck-title]");
  const title = (field?.value || "").trim();
  if (!title) {
    showToast("Enter a title first.");
    return;
  }
  if (title === (project.title || "")) {
    showToast("That's already the title.");
    return;
  }
  setBusy(button, true, "Updating...");
  try {
    const updated = await api(`/api/v1/projects/${project.id}/title`, {
      method: "PATCH",
      body: JSON.stringify({ title }),
    });
    hydrateProject(updated);
    showToast("Title updated.");
  } catch (error) {
    showToast(error.message);
  } finally {
    setBusy(button, false);
  }
}

if (pagesDeck) {
  pagesDeck.addEventListener("click", (event) => {
    const action = event.target.closest("[data-deck-action]");
    if (!action || action.disabled) return;
    const pageNumber = Number(action.dataset.deckPage || 0);
    switch (action.dataset.deckAction) {
      case "start":
        startGuidedGeneration();
        break;
      case "generate":
      case "regenerate":
        guidedGenerate(pageNumber);
        break;
      case "approve":
        guidedApprove(pageNumber);
        break;
      case "finish":
        guidedFinish();
        break;
      case "forum":
        toggleDeckForum(action);
        break;
      case "update-title":
        updateDeckTitle(action);
        break;
      case "suggest":
        suggestDeckLines(pageNumber, action);
        break;
      case "apply-suggestion":
        applyDeckSuggestion(action);
        break;
      case "remove-page":
        removeDeckPage(pageNumber);
        break;
      case "move-page-up":
        moveDeckPage(pageNumber, "up");
        break;
      case "move-page-down":
        moveDeckPage(pageNumber, "down");
        break;
      case "duplicate-page":
        duplicateDeckPage(pageNumber);
        break;
    }
  });

  deckTrack.addEventListener("input", (event) => {
    const field = event.target.closest("[data-deck-field]");
    if (!field || !project) return;
    const target = project.pages.find((page) => page.page_number === Number(field.dataset.deckPage));
    if (!target) return;
    target[field.dataset.deckField] = field.value;
    updateDeckCount(field);
    deckDirty = true;
    setDeckChip("dirty");
    window.clearTimeout(deckSaveTimer);
    deckSaveTimer = window.setTimeout(saveDeckEdits, 900);
  });

  // Data-loss guards: flush pending deck edits when the tab hides, and warn
  // before unloading while an edit is still unsaved (autosave debounce is
  // 900ms, so fast navigation could otherwise drop the last keystrokes).
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden" && deckDirty) saveDeckEdits();
  });
  window.addEventListener("beforeunload", (event) => {
    if (!deckDirty) return;
    saveDeckEdits();
    event.preventDefault();
    event.returnValue = "";
  });

  deckPrevBtn.addEventListener("click", () => goToDeckPage(deckIndex - 1));
  deckNextBtn.addEventListener("click", () => goToDeckPage(deckIndex + 1));
  deckDots.addEventListener("click", (event) => {
    const dot = event.target.closest("[data-deck-dot]");
    if (dot) goToDeckPage(Number(dot.dataset.deckDot));
  });
  if (draftStoryBtn) draftStoryBtn.addEventListener("click", () => draftStoryPages(false));
  if (redraftStoryBtn) redraftStoryBtn.addEventListener("click", () => draftStoryPages(true));

  deckViewport.addEventListener("keydown", (event) => {
    if (event.target.closest("input, textarea")) return;
    if (event.key === "ArrowLeft") {
      event.preventDefault();
      goToDeckPage(deckIndex - 1);
    } else if (event.key === "ArrowRight") {
      event.preventDefault();
      goToDeckPage(deckIndex + 1);
    }
  });

  deckViewport.addEventListener("pointerdown", (event) => {
    if (event.target.closest("input, textarea, button, a, select, summary")) return;
    if (deckTrack.children.length < 2) return;
    deckDrag = { id: event.pointerId, startX: event.clientX, startY: event.clientY, dx: 0, active: false };
  });
  deckViewport.addEventListener("pointermove", (event) => {
    if (!deckDrag || event.pointerId !== deckDrag.id) return;
    const dx = event.clientX - deckDrag.startX;
    const dy = event.clientY - deckDrag.startY;
    if (!deckDrag.active) {
      // Let vertical scrolling through; only claim clearly horizontal drags.
      if (Math.abs(dx) < 12 || Math.abs(dx) < Math.abs(dy)) return;
      deckDrag.active = true;
      try {
        deckViewport.setPointerCapture(event.pointerId);
      } catch {}
      deckTrack.classList.add("no-anim");
    }
    deckDrag.dx = dx;
    deckTrack.style.transform = `translateX(calc(${-deckIndex * 100}% + ${dx}px))`;
    event.preventDefault();
  });
  const endDeckDrag = (event) => {
    if (!deckDrag || event.pointerId !== deckDrag.id) return;
    const { dx, active } = deckDrag;
    deckDrag = null;
    if (!active) return;
    const threshold = Math.min(90, (deckViewport.clientWidth || 1) * 0.18);
    if (dx < -threshold) goToDeckPage(deckIndex + 1);
    else if (dx > threshold) goToDeckPage(deckIndex - 1);
    else updateDeckPosition(true);
  };
  deckViewport.addEventListener("pointerup", endDeckDrag);
  deckViewport.addEventListener("pointercancel", endDeckDrag);
}

// Asset URLs are deterministic (same key per page) and the asset endpoint sends
// a 1-hour Cache-Control, so re-lettered or regenerated art would show stale
// without a version param tied to the project's last update.
function assetUrl(url) {
  if (!url || !project?.updated_at) return url;
  return `${url}${url.includes("?") ? "&" : "?"}v=${encodeURIComponent(project.updated_at)}`;
}

function renderReferences() {
  const files = [...referenceInput.files].slice(0, 5);
  referenceStrip.innerHTML = files
    .map((file) => `<img src="${URL.createObjectURL(file)}" alt="${escapeHtml(file.name)}" />`)
    .join("");
}

async function createStoryboard(event) {
  event.preventDefault();
  if (!validatePage()) return;
  if (!validateCompleteBrief()) return;
  setBusy(submitBtn, true, "Creating...");
  try {
    // Series-first flow: create the series container, attach the character
    // passport (reference images), then generate chapter one as a linked
    // project. On retry (e.g. an upload hiccup) the draft series is reused
    // instead of creating a duplicate.
    if (!series?.id || project) {
      series = await api("/api/v1/series", {
        method: "POST",
        body: JSON.stringify(seriesPayload()),
      });
      project = null;
    }
    rememberSeries(series.id);
    if (!series.reference_urls?.length && referenceInput.files.length) {
      const uploadData = new FormData();
      [...referenceInput.files].slice(0, 5).forEach((file) => uploadData.append("files", file));
      const uploaded = await api(`/api/v1/series/${series.id}/references`, {
        method: "POST",
        body: uploadData,
      });
      series.reference_urls = uploaded.reference_urls || [];
      trackEvent("reference_uploaded", { asset_count: series.reference_urls.length, has_reference: true });
    }
    const chapter = await api(`/api/v1/series/${series.id}/chapters`, {
      method: "POST",
      body: JSON.stringify(chapterPayload()),
    });
    trackEvent("project_created", { page_count: CHAPTER_STORY_PAGES, series_id: series.id }, { projectId: chapter.id });
    hydrateProject(chapter);
    showView("studio");
    refreshSeries();
    trackEvent("storyboard_ready", { page_count: chapter.pages?.length || 0, has_reference: Boolean(chapter.reference_urls?.length) }, { projectId: chapter.id });
    showToast("Series created. Writing the chapter script...");
    // Draft the real storyboard right away so the creator lands on the
    // page-by-page review. Falls back to the in-deck CTA if it fails.
    await draftStoryPages(false);
  } catch (error) {
    trackEvent("generation_error_seen", { stage: "storyboard", error_type: error.name || "Error" });
    showToast(error.message);
  } finally {
    setBusy(submitBtn, false);
  }
}

async function refreshSeries() {
  if (!project?.series_id) {
    renderSeriesPanel();
    return;
  }
  try {
    series = await api(`/api/v1/series/${project.series_id}`);
    rememberSeries(series.id);
  } catch {
    // Keep whatever series state we have; the panel just won't update.
  }
  renderSeriesPanel();
}

function syncSeries() {
  if (project?.series_id && series?.id !== project.series_id) {
    refreshSeries();
    return;
  }
  renderSeriesPanel();
}

function renderSeriesPanel() {
  const inSeries = Boolean(project?.series_id);
  const chapters = inSeries && series?.id === project.series_id ? series.chapters || [] : [];
  if (seriesChapterBar && seriesChapterStrip) {
    seriesChapterBar.classList.toggle("hidden", !inSeries || !chapters.length);
    seriesChapterStrip.innerHTML = chapters
      .map((chapter) => {
        const active = chapter.project_id === project?.id;
        const status = chapter.pdf_url ? "Ready" : chapter.payment_status === "paid" ? "Paid" : "Draft";
        return `<button type="button" class="chapter-chip${active ? " active" : ""}" data-chapter-project="${chapter.project_id}" aria-pressed="${active}">
            <strong>Ch ${chapter.chapter_number}</strong><span>${escapeHtml(status)}</span>
          </button>`;
      })
      .join("");
  }
  if (nextChapterCard) {
    // Serialized order (B2): the next chapter only opens once THIS chapter is
    // finished (built PDF), matching the API gate so we never offer an action
    // that would just 409. Power users can still queue ahead via the API.
    const chapterBuilt = Boolean(project?.pdf_url);
    nextChapterCard.classList.toggle("hidden", !inSeries || !chapterBuilt);
  }
}

async function startNextChapter() {
  if (!project?.series_id) return;
  const seed = (nextChapterSeed?.value || "").trim();
  if (seed.length < 8) {
    showToast("Describe the next chapter in at least one quick sentence.");
    nextChapterSeed?.focus();
    return;
  }
  setBusy(nextChapterBtn, true, "Creating chapter...");
  try {
    const chapter = await api(`/api/v1/series/${project.series_id}/chapters`, {
      method: "POST",
      body: JSON.stringify({
        story_seed: seed,
        chapter_title: (nextChapterTitle?.value || "").trim(),
        page_count: CHAPTER_STORY_PAGES,
        must_include: "",
        avoid: "",
      }),
    });
    if (nextChapterSeed) nextChapterSeed.value = "";
    if (nextChapterTitle) nextChapterTitle.value = "";
    trackEvent("project_created", { page_count: CHAPTER_STORY_PAGES, series_id: project.series_id, chapter_number: chapter.chapter_number }, { projectId: chapter.id });
    hydrateProject(chapter);
    await refreshSeries();
    showToast(`Chapter ${chapter.chapter_number} created. Writing its script...`);
    window.scrollTo({ top: 0, behavior: "smooth" });
    await draftStoryPages(false);
  } catch (error) {
    trackEvent("generation_error_seen", { stage: "next_chapter", error_type: error.name || "Error" });
    showToast(error.message);
  } finally {
    setBusy(nextChapterBtn, false);
  }
}

// -- Series dashboard ("My series") ------------------------------------------
// No accounts exist yet, so the dashboard lists the series ids saved on this
// device (localStorage) and hydrates each one from its private link.

function getMySeriesIds() {
  try {
    const raw = JSON.parse(window.localStorage.getItem(MY_SERIES_KEY) || "[]");
    return Array.isArray(raw) ? raw.filter((id) => typeof id === "string" && id) : [];
  } catch {
    return [];
  }
}

function rememberSeries(seriesId) {
  if (!seriesId) return;
  try {
    const ids = getMySeriesIds().filter((id) => id !== seriesId);
    ids.unshift(seriesId);
    window.localStorage.setItem(MY_SERIES_KEY, JSON.stringify(ids.slice(0, 50)));
  } catch {}
}

function forgetSeries(seriesId) {
  try {
    window.localStorage.setItem(
      MY_SERIES_KEY,
      JSON.stringify(getMySeriesIds().filter((id) => id !== seriesId)),
    );
  } catch {}
}

async function openDashboard() {
  showView("dashboard");
  try {
    window.history.replaceState(null, "", `${window.location.pathname}?view=series`);
  } catch {}
  const ids = getMySeriesIds();
  if (!ids.length) {
    dashboardSeriesCache = [];
    renderDashboard();
    return;
  }
  seriesGrid.classList.remove("hidden");
  dashboardEmpty.classList.add("hidden");
  seriesGrid.innerHTML = `<div class="dashboard-loading">Loading your series...</div>`;
  const results = await Promise.allSettled(ids.map((id) => api(`/api/v1/series/${id}`)));
  dashboardSeriesCache = [];
  results.forEach((result, index) => {
    if (result.status === "fulfilled") {
      dashboardSeriesCache.push(result.value);
    } else if (String(result.reason?.message || "").toLowerCase().includes("not found")) {
      forgetSeries(ids[index]);
    }
  });
  renderDashboard();
}

function renderDashboard() {
  // Series with zero chapters are aborted wizard drafts; don't surface them.
  const list = dashboardSeriesCache.filter((item) => (item.chapters || []).length > 0);
  const hasSeries = list.length > 0;
  dashboardEmpty.classList.toggle("hidden", hasSeries);
  seriesGrid.classList.toggle("hidden", !hasSeries);
  if (!hasSeries) {
    seriesGrid.innerHTML = "";
    renderIcons();
    return;
  }
  seriesGrid.innerHTML = list
    .map((item) => {
      const chapters = item.chapters || [];
      const cover = [...chapters].reverse().find((chapter) => chapter.cover_url)?.cover_url;
      const readyCount = chapters.filter((chapter) => chapter.pdf_url).length;
      const updated = (item.updated_at || "").slice(0, 10);
      return `
        <article class="series-card" data-series-id="${item.id}">
          <div class="series-card-cover">
            ${cover ? `<img src="${assetUrl(cover)}" alt="${escapeHtml(item.title)} cover" loading="lazy" />` : `<i data-lucide="image"></i>`}
          </div>
          <div class="series-card-body">
            <h3>${escapeHtml(item.title)}</h3>
            <p>${escapeHtml(item.protagonist_name)} &middot; ${escapeHtml(item.genre)}</p>
            <div class="series-card-meta">
              <span>${chapters.length} chapter${chapters.length === 1 ? "" : "s"}</span>
              ${readyCount ? `<span>${readyCount} PDF${readyCount === 1 ? "" : "s"} ready</span>` : ""}
              ${updated ? `<span>Updated ${updated}</span>` : ""}
            </div>
          </div>
          <div class="series-card-actions">
            <button type="button" class="cta-btn" data-open-series="${item.id}">Open series</button>
            <button type="button" class="series-card-forget" data-forget-series="${item.id}" aria-label="Remove from this device" title="Remove from this device (the series itself is not deleted)">&times;</button>
          </div>
        </article>`;
    })
    .join("");
  renderIcons();
}

async function openSeries(seriesId) {
  try {
    const loadedSeries = await api(`/api/v1/series/${seriesId}`);
    const chapters = loadedSeries.chapters || [];
    if (!chapters.length) {
      showToast("This series has no chapters yet. Start a new series to begin.");
      return;
    }
    const latest = chapters[chapters.length - 1];
    const loaded = await api(`/api/v1/projects/${latest.project_id}`);
    series = loadedSeries;
    rememberSeries(seriesId);
    hydrateProject(loaded);
    showView("studio");
  } catch (error) {
    showToast(error.message);
  }
}

function startNewSeriesFromDashboard() {
  resetWizard(false);
  page = 0;
  updateStep();
  trackEvent("wizard_started", { source: "dashboard" });
  showView("wizard");
}

async function refreshProjectState() {
  if (!project?.id) return project;
  const refreshed = await api(`/api/v1/projects/${project.id}`);
  hydrateProject(refreshed);
  return project;
}

async function ensureReferenceUploads() {
  if (!project || project.reference_urls?.length) return project;
  await refreshProjectState();
  if (project.reference_urls?.length) return project;
  if (!referenceInput.files.length) return project;
  const uploadData = new FormData();
  [...referenceInput.files].slice(0, 5).forEach((file) => uploadData.append("files", file));
  const uploaded = await api(`/api/v1/projects/${project.id}/references`, {
    method: "POST",
    body: uploadData,
  });
  const uploadedReferenceUrls = uploaded.reference_urls || [];
  const refreshed = await api(`/api/v1/projects/${project.id}`);
  const referenceUrls = [];
  [...(refreshed.reference_urls || []), ...uploadedReferenceUrls].forEach((url) => {
    if (url && !referenceUrls.includes(url)) referenceUrls.push(url);
  });
  hydrateProject({ ...refreshed, reference_urls: referenceUrls });
  trackEvent("reference_uploaded", { asset_count: project.reference_urls?.length || 0, has_reference: Boolean(project.reference_urls?.length) });
  return project;
}

async function loadFromUrl() {
  const params = new URLSearchParams(window.location.search);
  if (params.get("view") === "series") {
    await openDashboard();
    return;
  }
  const seriesParam = params.get("series");
  const projectId = params.get("project");
  if (seriesParam && !projectId) {
    rememberSeries(seriesParam);
    await openSeries(seriesParam);
    return;
  }
  if (!projectId) return;
  try {
    const loaded = await api(`/api/v1/projects/${projectId}`);
    hydrateProject(loaded);
    showView("studio");
  } catch (error) {
    trackEvent("generation_error_seen", { stage: "load_project", error_type: error.name || "Error" });
    showToast(error.message);
  }
}

function openRestartModal() {
  restartModal.classList.remove("hidden");
  document.body.classList.add("modal-open");
  renderIcons();
}

function closeRestartModal() {
  restartModal.classList.add("hidden");
  document.body.classList.remove("modal-open");
}

// -- Chapter overview (contact sheet) -----------------------------------------

function buildDeckOverview() {
  if (!deckOverviewGrid || !project) return;
  const sorted = [...project.pages].sort((a, b) => a.page_number - b.page_number);
  const approvedThrough = project.approved_through || 0;
  const guided = deckMode() === "guided";
  deckOverviewGrid.innerHTML = sorted
    .map((page, index) => {
      const asset = deckAssetFor(page.page_number);
      const typeLabel = DECK_PAGE_TYPE_LABELS[page.page_type] || "Story";
      const label = typeLabel === "Story" ? `Page ${page.page_number}` : typeLabel;
      const done = guided && page.page_number <= approvedThrough;
      const thumb = asset?.url
        ? `<img src="${assetUrl(asset.url)}" alt="Page ${page.page_number} art" loading="lazy" draggable="false" />`
        : `<div class="deck-ov-placeholder"><i data-lucide="image"></i></div>`;
      const noteMark = (page.notes || "").trim()
        ? '<span class="deck-ov-note" title="Has private notes" aria-hidden="true"><i data-lucide="sticky-note"></i></span>'
        : "";
      return `<button type="button" class="deck-ov-cell${done ? " done" : ""}" data-ov-index="${index}" aria-label="Go to ${label}${noteMark ? " (has notes)" : ""}">
          <span class="deck-ov-thumb">${thumb}${done ? '<span class="deck-ov-badge" aria-hidden="true"><i data-lucide="check"></i></span>' : ""}${noteMark}</span>
          <span class="deck-ov-num">${escapeHtml(label)}</span>
          <span class="deck-ov-title">${escapeHtml(page.scene_title || "")}</span>
        </button>`;
    })
    .join("");
  renderIcons();
}

async function loadOverviewStats() {
  if (!deckOverviewStats || !project) return;
  deckOverviewStats.textContent = "";
  try {
    const s = await api(`/api/v1/projects/${project.id}/stats`);
    const mins = Math.max(1, Math.round((s.read_seconds || 0) / 60));
    const bits = [
      `${s.story_pages} story page${s.story_pages === 1 ? "" : "s"}`,
      `~${mins} min read`,
      `${s.total_words} words`,
    ];
    deckOverviewStats.textContent = bits.join("  ·  ");
  } catch {
    /* stats are non-essential; leave blank on failure */
  }
}

function openDeckOverview() {
  if (!deckOverviewModal || !project) return;
  buildDeckOverview();
  loadOverviewStats();
  deckOverviewModal.classList.remove("hidden");
  document.body.classList.add("modal-open");
  deckOverviewClose?.focus();
}

function closeDeckOverview() {
  if (!deckOverviewModal) return;
  deckOverviewModal.classList.add("hidden");
  document.body.classList.remove("modal-open");
  deckOverviewBtn?.focus();
}

function resetWizard(preserveName = true) {
  const name = preserveName ? briefValue("subject_name", landingName.value.trim()) : "";
  form.reset();
  project = null;
  series = null;
  renderSeriesPanel();
  setFieldValue("subject_name", name);
  page = 0;
  referenceStrip.innerHTML = "";
  deckSignature = "";
  deckProjectId = null;
  deckIndex = 0;
  deckDirty = false;
  deckGenerating = 0;
  deckActionBusy = false;
  deckForumPublished = null;
  deckForumProjectId = null;
  pagesDeck?.classList.add("hidden");
  downloadLink?.classList.add("hidden");
  document.querySelectorAll(".option-card.selected").forEach((card) => card.classList.remove("selected"));
  document.querySelectorAll(".option-card[aria-pressed]").forEach((card) => card.setAttribute("aria-pressed", "false"));
  updateCharacterCounter();
  updateStep();
  renderStatus();
  clearProjectUrl();
}

function applyPendingTemplate() {
  if (!pendingTemplate.occasion && !pendingTemplate.tone && !pendingTemplate.genre) return;
  if (pendingTemplate.occasion) setFieldValue("must_include", pendingTemplate.occasion);
  if (pendingTemplate.tone) setFieldValue("tone", pendingTemplate.tone);
  if (pendingTemplate.genre) setFieldValue("genre", pendingTemplate.genre);
  pendingTemplate = {};
  templateButtons.forEach((button) => {
    button.classList.remove("selected");
    button.setAttribute("aria-pressed", "false");
  });
}

function startWizard() {
  const name = landingName.value.trim();
  if (!name) {
    showToast("Add a name to start the comic.");
    landingName.focus();
    return;
  }
  setFieldValue("subject_name", name);
  applyPendingTemplate();
  page = 0;
  updateStep();
  trackEvent("wizard_started", { source: "landing_hero" });
  showView("wizard");
}

function escapeHtml(value) {
  return String(value || "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");
}

let CURRENT_USER = null;

async function hydrateHeaderAuth() {
  const headerAuth = document.querySelector("#headerAuth");
  if (!headerAuth) return;
  try {
    const response = await fetch("/api/v1/auth/me");
    if (!response.ok) { CURRENT_USER = null; return; }
    const user = await response.json();
    CURRENT_USER = user;
    renderHeaderAuth();
  } catch {}
}

function renderHeaderAuth() {
  const headerAuth = document.querySelector("#headerAuth");
  if (!headerAuth || !CURRENT_USER) return;
  const user = CURRENT_USER;
  const initial = (user.username || "?").charAt(0).toUpperCase();
  const credits = Number(user.credits || 0);
  const lowClass = credits <= 5 ? " is-low" : "";
  headerAuth.innerHTML = `
    <button type="button" class="lp-credit-chip${lowClass}" id="headerCreditChip" title="Generation credits — click to top up">
      &#9670; ${credits}
    </button>
    <a class="lp-auth-account" href="/account" title="My account">
      <span class="lp-auth-avatar">${escapeHtml(initial)}</span>
      <span class="lp-auth-name">${escapeHtml(user.username)}</span>
    </a>`;
  const chip = document.querySelector("#headerCreditChip");
  if (chip) chip.addEventListener("click", () => showBuyCreditsModal());
}

async function refreshCredits() {
  try {
    const res = await fetch("/api/v1/account/credits");
    if (!res.ok) return;
    const body = await res.json();
    if (CURRENT_USER) { CURRENT_USER.credits = body.credits; renderHeaderAuth(); }
  } catch {}
}

// In-studio credit top-up. Reuses GET /credit-packs + POST /account/credits/checkout
// so a creator never has to leave the studio to buy more (or recover from a 402).
async function showBuyCreditsModal(message) {
  if (!CURRENT_USER) { window.location.href = "/login"; return; }
  let packs = [];
  try { packs = (await (await fetch("/api/v1/credit-packs")).json()).packs || []; } catch {}
  const overlay = document.createElement("div");
  overlay.className = "scs-modal-overlay";
  overlay.setAttribute("role", "dialog");
  overlay.setAttribute("aria-modal", "true");
  overlay.setAttribute("aria-label", "Buy credits");
  const packCards = packs.map((p) =>
    `<button type="button" class="scs-pack" data-pack="${escapeHtml(p.id)}">
       <strong>${escapeHtml(p.label)}</strong>
       <span>${p.credits} credits</span>
       <span class="scs-pack-price">$${(p.price_cents / 100).toFixed(2)}</span>
     </button>`).join("");
  overlay.innerHTML = `
    <div class="scs-modal">
      <button type="button" class="scs-modal-close" aria-label="Close">&times;</button>
      <h2>Buy credits</h2>
      ${message ? `<p class="scs-modal-msg">${escapeHtml(message)}</p>` : ""}
      <p class="scs-modal-sub">You have <strong>${Number(CURRENT_USER.credits || 0)}</strong> credits. Each generated page costs 1.</p>
      <div class="scs-pack-grid">${packCards || "<p>No packs available.</p>"}</div>
    </div>`;
  const close = () => overlay.remove();
  overlay.addEventListener("click", (e) => { if (e.target === overlay) close(); });
  overlay.querySelector(".scs-modal-close").addEventListener("click", close);
  overlay.querySelectorAll("[data-pack]").forEach((btn) =>
    btn.addEventListener("click", async () => {
      btn.disabled = true;
      try {
        const body = await api("/api/v1/account/credits/checkout", {
          method: "POST",
          body: JSON.stringify({ pack_id: btn.dataset.pack }),
        });
        if (body.checkout_url) { window.location.href = body.checkout_url; return; }
        if (CURRENT_USER) { CURRENT_USER.credits = body.credits; renderHeaderAuth(); }
        showToast(`Added credits — you now have ${body.credits}.`);
        close();
      } catch (err) {
        showToast(err.message);
        btn.disabled = false;
      }
    }));
  document.body.appendChild(overlay);
}

window.addEventListener("scroll", () => {
  landingHeader?.classList.toggle("scrolled", window.scrollY > 8);
});

document.querySelectorAll('a[href^="#"]').forEach((link) => {
  link.addEventListener("click", (event) => {
    const target = document.querySelector(link.getAttribute("href"));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  });
});

function initScrollReveals() {
  const revealItems = [
    ...document.querySelectorAll(".builder-row, .builder-output, .story-card, .how-card, .example-card, .pricing-card, .faq-list details, .final-cta"),
  ];
  revealItems.forEach((item) => item.classList.add("reveal-ready"));
  if (!("IntersectionObserver" in window)) {
    revealItems.forEach((item) => item.classList.add("is-visible"));
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: "0px 0px -10% 0px", threshold: 0.14 },
  );
  revealItems.forEach((item) => observer.observe(item));
}

startWizardButtons.forEach((button) => button.addEventListener("click", startWizard));
landingStartBtn.addEventListener("click", startWizard);
templateButtons.forEach((button) => {
  button.addEventListener("click", () => {
    pendingTemplate = {
      occasion: button.dataset.templateOccasion || "",
      tone: button.dataset.templateTone || "",
      genre: button.dataset.templateGenre || "",
    };
    templateButtons.forEach((item) => {
      item.classList.remove("selected");
      item.setAttribute("aria-pressed", "false");
    });
    button.classList.add("selected");
    button.setAttribute("aria-pressed", "true");
    showToast("Template selected. Add the hero's name to start.");
    landingName.focus();
  });
});
landingName.addEventListener("keydown", (event) => {
  if (event.key === "Enter") {
    event.preventDefault();
    startWizard();
  }
});

nextBtn.addEventListener("click", () => goNext());
backBtn.addEventListener("click", () => {
  page = Math.max(page - 1, 0);
  updateStep();
  pages[page]?.querySelector("h1")?.focus?.({ preventScroll: true });
});

document.querySelectorAll(".option-card").forEach((card) => {
  card.addEventListener("click", () => {
    const target = card.dataset.optionTarget;
    const appendTarget = card.dataset.appendTarget;
    const value = card.dataset.optionValue || card.textContent.trim();
    const scope = card.closest(".step-page");
    const optionScope = card.closest("[data-option-group]") || scope;
    optionScope.querySelectorAll(".option-card").forEach((item) => {
      item.classList.remove("selected");
      item.setAttribute("aria-pressed", "false");
    });
    card.classList.add("selected");
    card.setAttribute("aria-pressed", "true");
    if (target) setFieldValue(target, value);
    if (appendTarget) appendFieldValue(appendTarget, value);
    // Visual style tiles also carry a catalog preset id (the freeform art_style
    // text stays the human-readable value/validation target).
    if (card.dataset.styleId) setFieldValue("style_id", card.dataset.styleId);
    if (!scope.dataset.manualNext) {
      window.setTimeout(() => goNext(true), 160);
    }
  });
});

document.querySelectorAll("[data-custom-target]").forEach((input) => {
  input.addEventListener("input", () => {
    const target = input.dataset.customTarget;
    setFieldValue(target, input.value.trim());
    // A freeform custom style clears any picked preset id so the backend
    // resolves the look by keyword instead of a stale tile selection.
    if (target === "art_style") setFieldValue("style_id", "");
    const scope = input.closest("[data-option-group]") || input.closest(".step-page");
    scope.querySelectorAll(".option-card").forEach((card) => {
      card.classList.remove("selected");
      card.setAttribute("aria-pressed", "false");
    });
  });
  input.addEventListener("keydown", (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      goNext();
    }
  });
});

document.querySelectorAll("[data-custom-append]").forEach((input) => {
  input.addEventListener("input", () => {
    const target = input.dataset.customAppend;
    const field = form.elements[target];
    if (field) field.value = input.value.trim();
    const scope = input.closest("[data-option-group]") || input.closest(".step-page");
    scope.querySelectorAll(".option-card").forEach((card) => {
      card.classList.remove("selected");
      card.setAttribute("aria-pressed", "false");
    });
  });
  input.addEventListener("keydown", (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      goNext();
    }
  });
});

storySparkButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const spark = button.dataset.storySpark || "";
    const existing = storySeedInput.value.trim();
    storySeedInput.value = existing ? `${existing}\n${spark}` : spark;
    storySeedInput.dispatchEvent(new Event("input", { bubbles: true }));
    storySeedInput.focus();
  });
});

function ideaHints() {
  const ideaDetails = [briefValue("story_seed"), briefValue("avoid") ? `Avoid: ${briefValue("avoid")}` : ""]
    .filter(Boolean)
    .join(" ")
    .slice(0, 1000);
  return {
    subject_name: briefValue("subject_name"),
    relationship: briefValue("relationship"),
    creator_name: briefValue("creator_name"),
    tone: briefValue("tone"),
    genre: briefValue("genre"),
    occasion: briefValue("must_include"),
    details: ideaDetails,
    count: IDEA_BATCH_SIZE,
    seed: ideaBatch,
  };
}

function renderIdeaCards(ideas) {
  if (!ideaResults) return;
  if (!ideas.length) {
    ideaResults.innerHTML = `<p class="idea-empty">No ideas came back. Try again or write your own below.</p>`;
    return;
  }
  ideaResults.innerHTML = ideas
    .map(
      (idea, index) => `
        <button type="button" class="idea-card" data-idea-index="${index}" style="--i:${index}">
          <span class="idea-card-title">${escapeHtml(idea.title)}</span>
          <span class="idea-card-premise">${escapeHtml(idea.premise)}</span>
          <span class="idea-card-use"><i data-lucide="corner-down-left"></i> Use this idea</span>
        </button>
      `,
    )
    .join("");
  ideaResults.querySelectorAll(".idea-card").forEach((card) => {
    const idea = ideas[Number(card.dataset.ideaIndex)];
    card.addEventListener("click", () => selectIdea(idea));
  });
  renderIcons();
}

function renderIdeaSkeletons(count = IDEA_BATCH_SIZE) {
  if (!ideaResults) return;
  ideaResults.innerHTML = Array.from({ length: count }, (_, index) => `<div class="idea-card skeleton" style="--i:${index}"></div>`).join("");
}

function selectIdea(idea) {
  if (!idea) return;
  storySeedInput.value = idea.premise;
  storySeedInput.dispatchEvent(new Event("input", { bubbles: true }));
  ideaResults.querySelectorAll(".idea-card").forEach((card) => card.classList.remove("chosen"));
  const chosen = [...ideaResults.querySelectorAll(".idea-card")].find((card) => card.querySelector(".idea-card-title")?.textContent === idea.title);
  chosen?.classList.add("chosen");
  showToast("Story idea added. Edit it freely below.");
  trackEvent("story_idea_selected", {});
  storySeedInput.focus();
  storySeedInput.scrollIntoView({ behavior: "smooth", block: "center" });
}

async function generateStoryIdeas() {
  if (!ideaGenerateBtn) return;
  if (!briefValue("subject_name")) {
    showToast("Add the hero's name first so the ideas are personal.");
    return;
  }
  ideaBatch += 1;
  setBusy(ideaGenerateBtn, true, "Thinking...");
  renderIdeaSkeletons(IDEA_BATCH_SIZE);
  try {
    const response = await api("/api/v1/story-ideas", {
      method: "POST",
      body: JSON.stringify(ideaHints()),
    });
    const ideas = response.ideas || [];
    renderIdeaCards(ideas);
    trackEvent("story_ideas_generated", { asset_count: ideas.length, source: response.provider });
  } catch (error) {
    ideaResults.innerHTML = `<p class="idea-empty">${escapeHtml(error.message)}</p>`;
    showToast(error.message);
  } finally {
    setBusy(ideaGenerateBtn, false);
    if (ideaBatch > 0) {
      ideaGenerateBtn.innerHTML = `<i data-lucide="wand-sparkles"></i> Suggest more ideas`;
      renderIcons();
    }
  }
}

if (ideaGenerateBtn) ideaGenerateBtn.addEventListener("click", generateStoryIdeas);

referenceInput.addEventListener("change", renderReferences);
storySeedInput.addEventListener("input", updateCharacterCounter);
form.addEventListener("submit", createStoryboard);
if (nextChapterBtn) nextChapterBtn.addEventListener("click", startNextChapter);
if (navMySeriesLink) {
  navMySeriesLink.addEventListener("click", (event) => {
    event.preventDefault();
    openDashboard();
  });
}
if (studioMySeriesBtn) studioMySeriesBtn.addEventListener("click", openDashboard);
if (dashboardNewSeriesBtn) dashboardNewSeriesBtn.addEventListener("click", startNewSeriesFromDashboard);
if (dashboardEmptyStartBtn) dashboardEmptyStartBtn.addEventListener("click", startNewSeriesFromDashboard);
if (seriesGrid) {
  seriesGrid.addEventListener("click", (event) => {
    const openButton = event.target.closest("[data-open-series]");
    if (openButton) {
      openSeries(openButton.dataset.openSeries);
      return;
    }
    const forgetButton = event.target.closest("[data-forget-series]");
    if (forgetButton) {
      const seriesId = forgetButton.dataset.forgetSeries;
      forgetSeries(seriesId);
      dashboardSeriesCache = dashboardSeriesCache.filter((item) => item.id !== seriesId);
      renderDashboard();
    }
  });
}
if (seriesChapterStrip) {
  seriesChapterStrip.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-chapter-project]");
    if (!button) return;
    const chapterProjectId = button.dataset.chapterProject;
    if (!chapterProjectId || chapterProjectId === project?.id) return;
    try {
      const loaded = await api(`/api/v1/projects/${chapterProjectId}`);
      hydrateProject(loaded);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (error) {
      showToast(error.message);
    }
  });
}
if (downloadLink) {
  downloadLink.addEventListener("click", () => {
    trackEvent("pdf_download_clicked", { has_pdf: Boolean(project?.pdf_url), page_count: project?.full_assets?.length || 0 });
  });
}
saveCloseBtn.addEventListener("click", () => {
  showView("landing");
  showToast("Draft kept in this browser tab.");
});
startOverBtn.addEventListener("click", openRestartModal);
studioRestartBtn.addEventListener("click", openRestartModal);
restartModalCancel.addEventListener("click", closeRestartModal);
restartModal.addEventListener("click", (event) => {
  if (event.target === restartModal) closeRestartModal();
});
restartModalConfirm.addEventListener("click", () => {
  closeRestartModal();
  resetWizard(true);
  showView("wizard");
  showToast("Started over.");
});
if (deckAddPageBtn) deckAddPageBtn.addEventListener("click", addDeckPage);
if (deckCheckBtn) deckCheckBtn.addEventListener("click", checkStoryboard);
if (deckCheckResults) {
  deckCheckResults.addEventListener("click", (event) => {
    const jump = event.target.closest("[data-check-page]");
    if (!jump || !project) return;
    const pageNum = Number(jump.dataset.checkPage);
    if (pageNum <= 0) return;
    const sorted = [...project.pages].sort((a, b) => a.page_number - b.page_number);
    const idx = sorted.findIndex((p) => p.page_number === pageNum);
    if (idx >= 0) goToDeckPage(idx);
  });
}
if (deckOverviewBtn) deckOverviewBtn.addEventListener("click", openDeckOverview);
if (deckOverviewClose) deckOverviewClose.addEventListener("click", closeDeckOverview);
if (deckOverviewModal) {
  deckOverviewModal.addEventListener("click", (event) => {
    if (event.target === deckOverviewModal) closeDeckOverview();
  });
  deckOverviewGrid.addEventListener("click", (event) => {
    const cell = event.target.closest("[data-ov-index]");
    if (!cell) return;
    goToDeckPage(Number(cell.dataset.ovIndex));
    closeDeckOverview();
  });
}
document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;
  if (deckOverviewModal && !deckOverviewModal.classList.contains("hidden")) {
    closeDeckOverview();
  } else if (!restartModal.classList.contains("hidden")) {
    closeRestartModal();
  }
});

// -- Landing: fresh-from-the-community showcase --------------------------------
// Fills the #community section with the latest shared chapters; the section
// stays hidden when the forum is empty or unreachable so the landing never
// shows a broken block.

async function loadCommunityShowcase() {
  const section = document.querySelector("#community");
  const grid = document.querySelector("#communityGrid");
  if (!section || !grid) return;
  try {
    const res = await fetch("/api/v1/forum?per_page=3");
    if (!res.ok) return;
    const body = await res.json();
    const posts = (body.posts || []).filter((p) => p.pdf_url).slice(0, 3);
    if (!posts.length) return;
    grid.innerHTML = posts
      .map((post) => {
        const cover = post.cover_url
          ? `<img src="${escapeHtml(post.cover_url)}" alt="${escapeHtml(post.title || "Shared chapter")} cover" loading="lazy" decoding="async" />`
          : `<div class="community-cover-empty" aria-hidden="true"></div>`;
        const sub = [post.series_title, post.chapter_number ? `Chapter ${post.chapter_number}` : ""]
          .filter(Boolean)
          .join(" · ");
        let started = false;
        try { started = Number(localStorage.getItem(`rd:pos:${post.project_id}`) || 0) > 0; } catch {}
        return `<a class="community-card" href="/read?project=${escapeHtml(post.project_id)}">
            ${cover}
            <div>
              <h3>${escapeHtml(post.title || "Untitled")}</h3>
              ${sub ? `<span>${escapeHtml(sub)}</span>` : ""}
              <small>by ${escapeHtml(post.author_name || "anonymous")}${started ? " · Continue reading →" : ""}</small>
            </div>
          </a>`;
      })
      .join("");
    section.classList.remove("hidden");
  } catch {
    /* forum unreachable — leave the section hidden */
  }
}

loadCommunityShowcase();

// -- SSE job progress subscription -------------------------------------------
// Connects to /api/jobs/{id}/events to receive live step-completion events.
// This is best-effort on serverless: if the EventSource connection fails or the
// server process differs from the worker, fall back to polling /api/jobs/{id}.
// The DB is always the authoritative source of truth.

let _activeJobSource = null;

function subscribeJobEvents(jobId, { onStep, onTerminal, onError } = {}) {
  if (_activeJobSource) {
    _activeJobSource.close();
    _activeJobSource = null;
  }
  if (!window.EventSource) {
    if (onError) onError(new Error("EventSource not supported"));
    return null;
  }
  const src = new window.EventSource(`/api/v1/jobs/${encodeURIComponent(jobId)}/events`);
  _activeJobSource = src;

  src.onmessage = function (event) {
    let data;
    try { data = JSON.parse(event.data); } catch { return; }
    const type = data.type || "";
    if (type === "step_complete" && onStep) {
      onStep(data);
    } else if (type === "terminal" || type === "complete" || type === "dead") {
      src.close();
      _activeJobSource = null;
      if (onTerminal) onTerminal(data);
    }
  };

  src.onerror = function () {
    src.close();
    _activeJobSource = null;
    if (onError) onError(new Error("SSE connection error"));
  };

  return src;
}

function closeJobEventSource() {
  if (_activeJobSource) {
    _activeJobSource.close();
    _activeJobSource = null;
  }
}

updateCharacterCounter();
updateStep();
initScrollReveals();
renderStatus();
renderIcons();
hydrateHeaderAuth();
trackEvent("landing_view", { view: "landing" });
loadFromUrl();
